jQuery( function( $ ) {
	// launches pop-up, only on first page view of session

	// if (!sessionStorage.alreadyPopped) {
	/**
	 *
	 */
	function popUp() {
		$( '#pop-up' ).addClass( 'open' );
		$( '#pop-up-container' ).addClass( 'open' );
		$( '#pop-up-container .pop-up-box' ).addClass( 'open' );
	}
	setTimeout( popUp, 1000 );
	// sessionStorage.alreadyPopped = 1;
	// }

	// closes pop-up

	$( '#pop-up, #pop-up-container .pop-up-box .close-pop' ).on( 'click', function() {
		$( '#pop-up' ).removeClass( 'open' );
		$( '#pop-up-container' ).removeClass( 'open' );
		$( '#pop-up-container .pop-up-box' ).removeClass( 'open' );
	} );

	$( document ).on( 'keyup', function( e ) {
		if (
			e.code === 'Escape' ||
			e.keyCode === 27
		) { // escape key maps to keycode `27`
			$( '#pop-up' ).removeClass( 'open' );
			$( '#pop-up-container' ).removeClass( 'open' );
			$( '#pop-up-container .pop-up-box' ).removeClass( 'open' );
		}
	} );

	// match height

	$( '#pop-up-container > div > div.pop-photo, #pop-up-container > div > div.pop-content' ).matchHeight();
} );
